import { Link } from '@material-ui/core';
import CloseIcon from '@mui/icons-material/Close';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import { BASKET_LINK_BY_LANG_ID } from '@settings/localization/consts';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';

import useDelivery from '../../../useDelivery';
import {
  CurrencyDifferenceDialogStyledContainer,
  CurrencyDifferenceStyledContainer,
} from './StyledComponents';

// Свойства компонента
export interface CurrencyDifferenceProps {
  isVisible: boolean;
  onClose: () => void;
}

const CurrencyDifference: FC<CurrencyDifferenceProps> = ({ isVisible, onClose }) => {
  const { t } = useTranslation(['Common']);

  const { useSettings } = useDelivery();
  const [settings] = useSettings().useState();

  const basketLink =
    BASKET_LINK_BY_LANG_ID[settings.primaryLanguageId] || BASKET_LINK_BY_LANG_ID.default;

  return (
    <>
      <CurrencyDifferenceDialogStyledContainer
        fullWidth
        maxWidth={'sm'}
        open={isVisible}
        onClose={() => onClose()}
        scroll={'body'}
      >
        <Box className="close-button">
          <IconButton onClick={() => onClose()}>
            <CloseIcon fontSize="large" />
          </IconButton>
        </Box>
        <CurrencyDifferenceStyledContainer>
          <b>
            <Typography sx={{ fontSize: '20px' }} variant={'subtitle1'}>
              {t('Common:CurrencyDifference.Title')}
            </Typography>
          </b>
          <Typography variant={'subtitle1'} component={'div'}>
            {t('Common:CurrencyDifference.Text.Part1')}{' '}
            <Link href={basketLink} underline="hover">
              {t('Common:CurrencyDifference.Text.BasketLink')}
            </Link>
            {t('Common:CurrencyDifference.Text.Part2')}
          </Typography>
        </CurrencyDifferenceStyledContainer>
      </CurrencyDifferenceDialogStyledContainer>
    </>
  );
};

export default CurrencyDifference;
